import {Component, inject, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {SearchModule} from "../../../search/search.module";

@Component({
    selector: "valumize-merge-search-dialog",
    standalone: true,
    imports: [MatDialogModule, SearchModule],
    encapsulation: ViewEncapsulation.None,
    template: `
        <mat-dialog-content class="merge-search-content">
            <valumize-search
                [searchCategories]="data.categories"
                [showSearchIcon]="false"
                [targetSearch]="true"
                (searchResultSelected)="onSelect($event)">
            </valumize-search>
        </mat-dialog-content>
    `,
    styles: [`
        .merge-search-content {
            padding: 16px 24px;
        }

        .merge-search-content valumize-search {
            display: block;
            width: 300px;
        }

        .merge-search-content valumize-search input {
            width: 100%;
            box-sizing: border-box;
        }
    `]
})
export class MergeSearchDialogComponent {
    private readonly dialogRef = inject(MatDialogRef<MergeSearchDialogComponent>);
    protected readonly data: { categories: string[] } = inject(MAT_DIALOG_DATA);

    onSelect(reference: string): void {
        this.dialogRef.close(reference);
    }
}
